import styled from 'styled-components';

export default styled.div`
  .documnet-container-empty{
    display: flex;
    background: #FAFAFA;
    height: 220px;
    padding: 40px 0;
    border-radius: 4px;
    justify-content: center;
    margin-bottom: 40px;
    margin-right: 0px;

    .ant-empty {
      margin: auto 0;
    }
  }

  .type-tag { 
    margin-right: 0px;
    width: 100px;
    text-align: center;

    .anticon {
      margin-right: 0px;
    }

    svg {
      margin-top: -2px;
    }
  }

  .image-container {
    margin-bottom: 40px;

    .ant-image {
      height: 150px;
      width: 250px !important;
    }

    .ant-image-img {
      height: 100%;
      object-fit: cover;
    }
  }

  .table-body {
    width: 100%;
    background: #fbfbfb;
    border: 1px solid #f2f2f2;
    padding: var(--size);
  }

  .ant-btn-icon-only .anticon {
    margin-right: 0;
  }

  .value {
    margin-bottom: 0px;
  }

  .buttons {
    margin-top: 12px;
    display: flex;
    justify-content: center;
    gap: 10px;

    .ant-btn {
      min-width: 140px;

      &.big-width {
        width: 200px;

        svg {
          margin-top: -3px;
        }
      }
    }
  }
`;
